import { useState, useLayoutEffect } from 'react';

// This hook will track the browser window's dimensions
export default function useWindowSize() {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    // Add event listener
    window.addEventListener('resize', updateSize);
    
    // Call handler right away so state gets updated with initial window size
    updateSize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}